export default {
	depots: [],
	totalDepots: 0,
};
